import React, { useState, useRef, useEffect } from 'react';
import { BsCalendar, BsX } from 'react-icons/bs';

const DateFilter = ({
  onDateChange,
  className = '',
  placeholder = 'Select date range',
  showClearButton = true,
  format = 'MM/DD/YYYY',
  minDate,
  maxDate,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDateChange = (type, value) => {
    if (type === 'start') {
      setStartDate(value);
      if (endDate && value > endDate) {
        setEndDate(value);
      }
    } else {
      setEndDate(value);
      if (startDate && value < startDate) {
        setStartDate(value);
      }
    }
  };

  const handleApply = () => {
    if (startDate && endDate) {
      onDateChange({ startDate, endDate });
      setIsOpen(false);
    }
  };

  const handleClear = () => {
    setStartDate('');
    setEndDate('');
    onDateChange({ startDate: '', endDate: '' });
  };

  // const formatDate = (date) => {
  //   if (!date) return '';
  //   const d = new Date(date);
  //   return d.toLocaleDateString('en-US', {
  //     month: '2-digit',
  //     day: '2-digit',
  //     year: 'numeric'
  //   });
  // };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d)) return '';

    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('en-US', { month: 'short' }); // 'Jan', 'Feb', etc.
    const year = d.getFullYear();

    return `${day} ${month} ${year}`;
  };

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`inline-flex items-center px-2.5 py-1.5 border border-gray-200 text-sm font-medium rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-300 ${(startDate || endDate) ? '' : ''
          }`}
      >
        <BsCalendar className="h-4 w-4 sm:mr-1.5" />
        <span className="hidden sm:inline">
          {startDate && endDate
            ? `${formatDate(startDate)} - ${formatDate(endDate)}`
            : placeholder}
        </span>
        {(startDate || endDate) && showClearButton && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleClear();
            }}
            className="ml-1.5 p-0.5 rounded-full hover:bg-gray-100"
          >
            <BsX className="h-3.5 w-3.5 text-gray-500" />
          </button>
        )}
      </button>

      {isOpen && (
        <div className="absolute left-0 z-50 mt-1 overflow-hidden origin-top-left bg-white rounded-lg shadow-lg w-fit ring-1 ring-black ring-opacity-5 sm:origin-top-right">
          <div className="p-4">
            <div className="space-y-4">
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700 whitespace-nowrap">
                  Start Date
                </label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => handleDateChange('start', e.target.value)}
                  min={minDate}
                  max={endDate || maxDate}
                  className="block w-full px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700 whitespace-nowrap">
                  End Date
                </label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => handleDateChange('end', e.target.value)}
                  min={startDate || minDate}
                  max={maxDate}
                  className="block w-full px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
            <div className="flex justify-end mt-4 space-x-2">
              <button
                onClick={() => setIsOpen(false)}
                className="px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors duration-150 whitespace-nowrap"
              >
                Cancel
              </button>
              <button
                onClick={handleApply}
                disabled={!startDate || !endDate}
                className="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateFilter; 